import './index.scss';

const groups = [
  {
    label: 'Engineering & Research',
    jobs: [
      {
        period: 'Sep 2026 – Present',
        company: 'University of British Columbia',
        tags: [{ label: 'Teaching' }],
        role: 'Teaching Assistant – CMPE 201',
        bullets: [
          <>Mentor 20+ students pairing course support with broader engineering career advice and grade coursework.</>,
        ],
      },
      {
        period: 'May 2026 – Present',
        company: 'UBCO Parking Services',
        tags: [
          { label: 'Full-stack' },
          { label: 'Analytics' },
          { label: 'AI integration' },
        ],
        role: 'Technology & AI Integration Assistant',
        bullets: [
          <>Shipped a live parking occupancy widget at parking.ok.ubc.ca's home page, giving a campus community of <strong>10,000+ students</strong> real-time parking availability.</>,
          <>Replaced a third-party payment-validation tool with an internal solution, cutting compliance officers' lookup time by <strong>10%</strong> and saving <strong>$240/year</strong> in subscription costs.</>,
          <>Building a unified parking analytics platform that brings license plate recognition, sensor, and payment data together for centralized reporting and natural-language queries.</>,
        ],
      },
      {
        period: 'May – Jul 2025',
        company: 'Forestallers (Startup)',
        tags: [
          { label: 'Internship', color: 'green' },
          { label: 'SAP' },
          { label: 'ABAP' },
        ],
        role: 'SAP Technical Intern',
        bullets: [
          <>Automated a repetitive SAP authorization process in ABAP, turning manual steps into a reusable internal workflow.</>,
          <>Refactored duplicated screen logic into reusable ABAP subroutines used across multiple internal projects.</>,
          <>Reworked an authorization interface from <strong>six screens to one</strong>, reducing unnecessary navigation for users.</>,
        ],
      },
    ],
  },
  {
    label: 'Leadership & Sales',
    jobs: [
      {
        period: 'Sep 2026 – Present',
        company: 'University of British Columbia',
        tags: [{ label: 'Leadership' }],
        role: 'Programme Residence Advisor',
        bullets: [
          <>Mentor and assist a team of <strong>85 Residence Advisors</strong> with event planning and take care of resourcing and inventory needs.</>,
        ],
      },
      {
        period: 'Aug 2025 – Apr 2026',
        company: 'University of British Columbia',
        tags: [{ label: 'Leadership' }],
        role: 'Residence Advisor',
        bullets: [
          <>Mentor <strong>40+ first-year students</strong> — crisis response, community building, pastoral care. High-ownership role on top of a full course load.</>,
        ],
      },
      {
        period: 'Jan 2025 – Apr 2025',
        company: "UBC Students' Union Okanagan",
        tags: [{ label: 'Leadership' }],
        role: 'Clinic Coordinator',
        bullets: [
          <>Managed, trained, and scheduled <strong>12 volunteers</strong> to deliver consistent clinic operations — handled customer-facing responsibilities and ensured smooth day-to-day service.</>,
        ],
      },
      {
        period: 'Sep 2023 – Feb 2025',
        company: 'Staples',
        tags: [{ label: 'Sales' }],
        role: 'Wireless Consultant',
        bullets: [
          <>Ranked in the <strong>top 150 nationwide</strong> for 5 consecutive months. <strong>+20% sales</strong> individually.</>,
        ],
      },
    ],
  },
];

const Experience = () => (
  <section id="work">
    <div className="sec-head reveal">
      <span className="sec-label">02</span>
      <h2 className="sec-title">Experience</h2>
    </div>

    {groups.map((group, gi) => (
      <div className="exp-group reveal" key={gi}>
        <div className="exp-group-label">{group.label}</div>

        {group.jobs.map((job, i) => (
          <div className="exp-item" key={i}>
            {/* LEFT — role first (most scannable), company + period secondary */}
            <div className="exp-meta">
              <div className="exp-role">{job.role}</div>
              <div className="exp-co-name">{job.company}</div>
              <div className="exp-period">{job.period}</div>
              <div className="exp-tags">
                {job.tags.map((t, j) => (
                  <span className={`tag${t.color ? ' ' + t.color : ''}`} key={j}>
                    {t.label}
                  </span>
                ))}
              </div>
            </div>
            {/* RIGHT — bullets only */}
            <ul className="exp-bullets">
              {job.bullets.map((b, k) => (
                <li key={k}>{b}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    ))}
  </section>
);

export default Experience;
